import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

import { EffectCoverflow, Pagination, Navigation } from 'swiper/modules';

// Import images
import image1 from '../../assets/images/others/grid1.jpeg';
import image2 from '../../assets/images/others/ladder13.jpeg';
import image3 from '../../assets/images/others/grid3.jpeg';
import image4 from '../../assets/images/others/grid4.jpeg';
import image5 from '../../assets/images/others/grid5.jpeg';
import image6 from '../../assets/images/others/ladderlong.jpeg';
import image7 from '../../assets/images/others/gridimg5.jpeg';
import image8 from '../../assets/images/others/ladder111 (1).jpeg';
import image9 from '../../assets/images/others/ladder31.jpeg';
import image10 from '../../assets/images/others/ladder41.jpeg';

const Products = () => {
  const slides = [
    { image: image1 },
    { image: image2 },
    { image: image3 },
    { image: image4 },
    { image: image5 },
    { image: image6 },
    { image: image7 },
    { image: image8 },
    { image: image9 },
    { image: image10 },
  ];

  // Set initialSlide to the middle slide (index 5 for 10 slides)
  const initialSlideIndex = Math.floor(slides.length / 2);

  return (
    <>
      <section className=" bg-gray-100 overflow-hidden">
        <div className='container mx-auto px-4 py-5 md:py-10 lg:py-14' data-aos="fade-zoom-in"
     data-aos-easing="ease-in-back"
     data-aos-delay="300"
     data-aos-offset="0">
        <h2 className="text-center text-3xl font-bold mb-6 md:mb-10 text-[#142a4e]">Our Products</h2>
        <Swiper
          effect={'coverflow'}
          grabCursor={true}
          centeredSlides={true}
          initialSlide={initialSlideIndex}
          coverflowEffect={{
            rotate: 0,   // Keep it simple to avoid too much distortion
            stretch: 0,
            depth: 100,
            modifier: 2.5,
            slideShadows: false,
          }}
          spaceBetween={0} // Adjust spacing between slides
          modules={[EffectCoverflow, Pagination, Autoplay, Navigation]}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          loop={true}
          className="mySwiper"
          breakpoints={{
            // Mobile
            320: {
              slidesPerView: 1,
              coverflowEffect: {
                rotate: 50,
                stretch: 0,
                depth: 300,
                modifier: 1,
                slideShadows: true,
              },
            },
            // Tablet
            640: {
              slidesPerView: 2,
              coverflowEffect: {
                rotate: 10,
                stretch: 0,
                depth: 200,
                modifier: 3,
                slideShadows: true,
              },
            },
            // Desktop
            1024: {
              slidesPerView: 5,  // Show 3 slides for desktop for balanced view
              coverflowEffect: {
                rotate: 10,
                stretch: 0,
                depth: 250,
                modifier: 2.5,
                slideShadows: false,
              },
            },
            // Large Screens
            1400: {
              slidesPerView: 5, // Show more slides on larger screens
              coverflowEffect: {
                rotate: 20,
                stretch: 60,
                depth: 200,
                modifier: 1.2,
                slideShadows: false,
              },
            },
          }}
        >
          {slides.map((slide, index) => (
            <SwiperSlide key={index}>
              <img src={slide.image} alt={`Slide ${index}`} className="rounded-lg md:rounded-xl shadow-md w-full h-96 md:w-80" />
            </SwiperSlide>
          ))}
        </Swiper>
        </div>
      </section>
    </>
  );
};

export default Products;
